import axios from "axios";

const state = {
  packages: [],
  currentPackage: null,
  selectedPackage: null,
  loading: false,
  error: null,
};

const getters = {
  allPackages: (state) => state.packages,
  currentPackage: (state) => state.currentPackage,
  selectedPackage: (state) => state.selectedPackage,
  isLoading: (state) => state.loading,
  getError: (state) => state.error,
};

const actions = {
  async fetchPackages({ commit }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await axios.get("/subscription-packages");
      commit("SET_PACKAGES", response.data.data.data);
      return response.data;
    } catch (error) {
      commit(
        "SET_ERROR",
        error.response?.data?.message || "فشل في تحميل الباقات"
      );
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchPackageDetails({ commit }, packageId) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await axios.get(`/subscription-packages/${packageId}`);
      commit("SET_SELECTED_PACKAGE", response.data.data.data);
      return response.data;
    } catch (error) {
      commit(
        "SET_ERROR",
        error.response?.data?.message || "فشل في تحميل تفاصيل الباقة"
      );
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async purchasePackage({ commit }, { packageId, paymentMethod }) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await axios.post(
        `/subscription-packages/${packageId}/pay`,
        {
          pay: 1,
          payment_method: paymentMethod,
        }
      );
      return response.data;
    } catch (error) {
      commit(
        "SET_ERROR",
        error.response?.data?.message || "فشل في عملية الدفع"
      );
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  setCurrentPackage({ commit }, packageData) {
    commit("SET_CURRENT_PACKAGE", packageData);
  },

  clearSelectedPackage({ commit }) {
    commit("SET_SELECTED_PACKAGE", null);
  },
};

const mutations = {
  SET_PACKAGES(state, packages) {
    state.packages = packages;
  },

  SET_CURRENT_PACKAGE(state, packageData) {
    state.currentPackage = packageData;
  },

  SET_SELECTED_PACKAGE(state, packageData) {
    state.selectedPackage = packageData;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_ERROR(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
